import {App} from "../App";
import React from "react";
import DownloadApp from "./Root";

export const DownloadPage = () => {
  return (
    <App>
      <DownloadApp showQRCode titleColor={"#052337"} />
    </App>
  );
};
